import {figmaElement} from "../figma-tree";
const assetPathPrefix = "/static/assets/5045164b-4a49-4d46-9c81-09483053321f";
const imgIconLucideX = `${assetPathPrefix}/48cb0.svg`;

type ArchiveButtonProps = {
  className?: string;
  label?: string;
  state?: "Default";
  style?: "Secondary" | "Caution";
};

function ArchiveButton({ className, label = "强制通过", state = "Default", style = "Caution" }: ArchiveButtonProps) {
  const isCautionAndDefault = style === "Caution" && state === "Default";
  return (
    <div className={className || `border border-solid content-stretch flex gap-[var(--archive-space-8,8px)] h-[44px] items-center justify-center p-[var(--archive-space-8,8px)] relative rounded-[var(--archive-radius-4,4px)] w-[104px] ${isCautionAndDefault ? "bg-[var(--action-caution-bg,#f3e7d2)] border-[var(--action-caution-border,#bda276)]" : "border-[var(--action-secondary,#626b78)]"}`} id={isCautionAndDefault ? "node-291_3291" : "node-8_13"}>
      {style === "Secondary" && state === "Default" && (
        <p className="[word-break:break-word] font-['Noto_Sans_SC:Medium'] font-medium leading-[24px] relative shrink-0 text-[14px] text-[color:var(--action-secondary,#626b78)] whitespace-nowrap" data-node-id="8:14">
          {label}
        </p>
      )}
      {isCautionAndDefault && (
        <p className="[word-break:break-word] font-['Noto_Sans_SC:Medium'] font-medium leading-[24px] relative shrink-0 text-[14px] text-[color:var(--action-caution-text,#765923)] whitespace-nowrap" data-node-id="291:3292">
          {label}
        </p>
      )}
    </div>
  );
}

export default function Component92() {
  return (
    <div className="bg-[var(--archive-bg-surface,white)] border border-[var(--archive-border-default,#e1e5eb)] border-solid content-stretch flex flex-col gap-[var(--archive-space-16,16px)] items-start overflow-clip p-[var(--archive-space-24,24px)] relative rounded-[var(--archive-radius-4,4px)] size-full" data-node-id="298:4086" data-name="92 / 账户管理 · 停用确认">
      <div className="content-stretch flex gap-[var(--archive-space-8,8px)] h-[28px] items-center overflow-clip p-[var(--archive-space-0,0px)] relative shrink-0 w-[552px]" data-node-id="298:4087" data-name="Dialog heading">
        <p className="[word-break:break-word] flex-[1_0_0] font-['Noto_Sans_SC:Bold'] font-bold leading-[28px] min-w-px relative text-[20px] text-[color:var(--archive-status-danger,#be343b)]" data-node-id="298:4088">
          停用账户？
        </p>
        <button className="content-stretch cursor-pointer flex gap-[var(--archive-space-8,8px)] items-center justify-center overflow-clip p-[var(--archive-space-0,0px)] relative shrink-0 size-[24px]" data-node-id="298:4089" data-name="Close dialog">
          <div className="relative shrink-0 size-[16px]" data-node-id="298:4090" data-name="Icon/Lucide/x">
            <img alt="" className="absolute block inset-0 max-w-none size-full" src={imgIconLucideX} />
          </div>
        </button>
      </div>
      <p className="[word-break:break-word] font-['Noto_Sans_SC:Medium'] font-medium leading-[24px] relative shrink-0 text-[14px] text-[color:var(--archive-text-primary,#20242c)] w-[552px]" data-node-id="298:4093">
        姜德广 · jiangdg
      </p>
      <p className="[word-break:break-word] font-['Noto_Sans_SC:Regular'] font-normal leading-[24px] relative shrink-0 text-[14px] text-[color:var(--archive-text-secondary,#8a929f)] w-[552px]" data-node-id="298:4094">
        停用后无法登录。已有案件、文件和处理记录继续保留，之后可重新启用。
      </p>
      <div className="content-stretch cursor-pointer flex gap-[var(--archive-space-8,8px)] h-[40px] items-start justify-end overflow-clip p-[var(--archive-space-0,0px)] relative shrink-0 w-[552px]" data-node-id="298:4095" data-name="Dialog actions">
        <ArchiveButton className="border border-[var(--action-secondary,#626b78)] border-solid content-stretch flex gap-[var(--archive-space-8,8px)] h-[36px] items-center justify-center p-[var(--archive-space-8,8px)] relative rounded-[var(--archive-radius-4,4px)] shrink-0 w-[88px]" label="取消" style="Secondary" />
        <button className="bg-[var(--archive-status-danger-bg,#fff0f0)] border border-[var(--archive-status-danger,#be343b)] border-solid content-stretch flex gap-[var(--archive-space-8,8px)] h-[40px] items-center justify-center p-[var(--archive-space-8,8px)] relative rounded-[var(--archive-radius-4,4px)] shrink-0 w-[128px]" data-node-id="298:4098" data-name="确认停用">
          <p className="[word-break:break-word] font-['Noto_Sans_SC:Medium'] font-medium leading-[24px] relative shrink-0 text-[14px] text-[color:var(--archive-status-danger,#be343b)] text-left whitespace-nowrap" data-node-id="I298:4098;291:3292">
            确认停用
          </p>
        </button>
      </div>
    </div>
  );
}
